import { useMutation } from '@tanstack/react-query';
import { confirmPickedUpAndDelivered } from '../services';

const useConfirmPickedUpAndDelivered = () => {
  return useMutation({
    mutationKey: ['confirmPickedUpAndDelivered'],
    mutationFn: async (payload) => await confirmPickedUpAndDelivered(payload),
    retry: 3,
  });
};

export default useConfirmPickedUpAndDelivered;
